//
// Log messages to the console.
function AdsNinjaLogger(){

    this.DEFAULT_MESSAGE_PILL     = 'AdsNinja';
    this.DEFAULT_STYLE_PILL       = 'display: inline-block; padding: 1px 4px; border-radius: 3px;';
    this.DEFAULT_STYLE_PILL_DEBUG = 'background: blue; color: #fff;';
    this.DEFAULT_STYLE_PILL_WARN  = 'background: yellow; color: #000;';
    this.DEFAULT_STYLE_PILL_ERROR = 'background: red; color: #fff;';

    this.__debug = false;

    // Check if debug param is presnt in query string. If it is present, set debug to true.
    if(URLSearchParams){

        var urlParams = new URLSearchParams(window.location.search);

        if(urlParams.has('an_debug')){
    
            var urlParamsDebug = urlParams.get('an_debug');
            urlParamsDebug     = (urlParamsDebug === '0' || urlParamsDebug === 'false') ? false : urlParamsDebug; 
            this.__debug       = Boolean(urlParamsDebug);

            localStorage.setItem('an_debug', this.__debug);
        }
        else{

            var localStorageDebug = localStorage.getItem('an_debug');
            localStorageDebug     = (localStorageDebug === '0' || localStorageDebug === 'false') ? false : localStorageDebug; 
            localStorageDebug     = Boolean(localStorageDebug);
            this.__debug          = Boolean(this.__debug || localStorageDebug);
        }
    }
}

//
// Returns debug status.
AdsNinjaLogger.prototype.isDebug = function(){

    return this.debug;
}

//
// Returns log data.
AdsNinjaLogger.prototype.__getLogData = function(data, takeDataSnapshot = true){

    var logData = null;

    if(typeof data === 'object' && Object.keys(data).length !== 0 && data !== null){

        logData = data;

        if(takeDataSnapshot){

            try{

                // To keep current state of data intact.
                logData = JSON.parse(JSON.stringify(data));
            }
            catch(error){

                this.warn(error.message, {
                    error: error,
                    data: data,
                }, false);

                // Circular logic detected.
                logData = data;
            }
        }
    }
    else{

        logData = '';
    }

    return logData;
}

//
// Logs to console with default level.
AdsNinjaLogger.prototype.log = function(message, data = {}, takeDataSnapshot = true){

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.log(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_DEBUG}`,
        message,
        logData
    );
}

//
// Logs to console with info level.
AdsNinjaLogger.prototype.info = function(message, data = {}, takeDataSnapshot = true){

    this.log(message, data, takeDataSnapshot);
}

//
// Logs to console with debug level.
AdsNinjaLogger.prototype.debug = function(message, data = {}, takeDataSnapshot = true){

    if(!this.__debug){

        return;
    }

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.debug(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_DEBUG}`,
        message,
        logData
    );
}

//
// Logs to console with warn level.
AdsNinjaLogger.prototype.warn = function(message, data = {}, takeDataSnapshot = true){

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.warn(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_WARN}`,
        message,
        logData
    );
}

//
// Logs to console with error level. 
AdsNinjaLogger.prototype.error = function(message, data = {}, takeDataSnapshot = true){

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.error(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_ERROR}`,
        message,
        logData
    );
}

window.AdsNinjaLogger = AdsNinjaLogger;